import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../config/firebase';
import { v4 as uuidv4 } from 'uuid';

export const uploadProductImage = async (file: File): Promise<string> => {
  try {
    // Generate a unique filename with timestamp to avoid conflicts
    const timestamp = new Date().getTime();
    const fileExtension = file.name.split('.').pop();
    const fileName = `products/${timestamp}-${uuidv4()}.${fileExtension}`;
    
    // Create a reference to the file location
    const storageRef = ref(storage, fileName);
    
    // Upload the file
    const snapshot = await uploadBytes(storageRef, file, {
      contentType: file.type,
      customMetadata: {
        'Access-Control-Allow-Origin': 'https://controlo.emtuacasa.pt',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
        'Access-Control-Allow-Headers': '*'
      }
    });
    
    // Get the download URL
    const downloadURL = await getDownloadURL(snapshot.ref);
    return downloadURL;
  } catch (error) {
    console.error('Error uploading image:', error);
    throw new Error('Failed to upload image');
  }
};

export const uploadMultipleProductImages = async (files: File[]): Promise<string[]> => {
  try {
    const uploadPromises = files.map(file => uploadProductImage(file));
    return await Promise.all(uploadPromises);
  } catch (error) {
    console.error('Error uploading multiple images:', error);
    throw new Error('Failed to upload one or more images');
  }
};
